export enum TRANSLATION_KEYS {
  ACCOUNT = 'account',
  AUTOCANADA = 'autocanada',
  COMMON = 'common',
  FEEDBACK = 'feedback',
  FAVOURITES = 'favourites',
  FORGOT_PASSWORD = 'forgot_password',
  GLOBAL_FOOTER = 'global_footer',
  GLOBAL_HEADER = 'global_header',
  HOME = 'home',
  LISTING = 'listing',
  LOGIN = 'login',
  MOBILE_LINK = 'mobile_link',
  NOT_FOUND = '404',
  REGISTER = 'register',
  RESET_PASSWORD = 'reset_password',
  ROUTES = 'routes',
  SRP = 'srp',
  VIP = 'vip',
}
